/* app/js/src/components/calendar/calendar-list.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.comments div[contenteditable=true]:focus::-webkit-scrollbar,
.calendar-list-container::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.comments div[contenteditable=true]:focus::-webkit-scrollbar-button,
.calendar-list-container::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.comments div[contenteditable=true]:focus::-webkit-scrollbar-corner,
.calendar-list-container::-webkit-scrollbar-corner {
  background: transparent;
}
.comments div[contenteditable=true]:focus::-webkit-scrollbar-thumb:hover,
.calendar-list-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.comments div[contenteditable=true]:focus::-webkit-scrollbar-thumb,
.calendar-list-container::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.comments div[contenteditable=true]:focus::-webkit-scrollbar-thumb:hover,
.calendar-list-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.comments div[contenteditable=true]:focus::-webkit-scrollbar-track:hover,
.calendar-list-container::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.comments div[contenteditable=true]:focus::-webkit-scrollbar-track,
.calendar-list-container::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.comments div[contenteditable=true]:focus::-webkit-scrollbar-thumb,
.calendar-list-container::-webkit-scrollbar-thumb {
  border-width: 0;
}
:host {
  border-top: solid 1px #e3e6ea;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 1px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  position: relative;
}
.calendar-list-container {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 39px);
  position: relative;
}
.calendar-list-container,
.empty-space-outside {
  top: 0;
  left: 0;
  width: 100%;
}
.calendar-list-container {
  z-index: 1;
}
.empty-space-outside {
  position: absolute;
  height: 100%;
}
header {
  display: flex;
  justify-content: flex-start;
  font-size: 10px;
  font-weight: bold;
  color: #232f3a;
  height: 45px;
  line-height: 45px;
  padding-left: 20px;
  border-bottom: solid 1px #e3e6ea;
}
.long-media-indicator {
  display: none;
}
.video-section {
  cursor: pointer;
}
.video-section.live-show {
  background-color: #ffcccc !important;
}
.video-section.live-show .duration .current-remaining-duration {
  color: #b75e5e;
}
.video-section.broadcast-show {
  background-color: rgb(248, 242, 255) !important;
}
.video-section.broadcast-show .duration .current-remaining-duration {
  color: #853eea;
}
.video-section.layout-show {
}
.video-section.layout-show .duration .current-remaining-duration {
  color: #b75e5e;
}
evrideo-layout-icon {
  float: left;
  margin-top: 19px;
  margin-left: -6px;
  transform: scale(0.8);
}
.dragging .video-section > *,
.dragging .before-time > * {
  pointer-events: none;
}
section {
  display: flex;
  justify-content: flex-start;
  font-size: 12px;
  height: 60px;
  line-height: 60px;
  border-bottom: solid 1px #e3e6ea;
  padding-left: 20px;
  position: relative;
}
section.media-section {
  height: initial;
  flex-direction: column;
  border: none;
  padding: 0;
}
section.media-section > section:hover .long-media-indicator {
  display: block;
  line-height: 1.7em;
  background-color: #40c4ff;
  color: white;
  font-family: "Open Sans";
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  opacity: 0.98;
  font-size: 12px;
  text-align: center;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
}
.playout {
  flex-basis: 150px;
}
.playout-media {
  flex-basis: 120px;
  padding-top: 7px;
}
.playout-background {
  height: 45px;
  width: 80px;
  background-size: cover;
}
.origin-filename,
.name {
  text-overflow: ellipsis;
  overflow: hidden;
  flex-grow: 1;
  flex-basis: 150px;
}
.sec-events {
  text-overflow: ellipsis;
  flex-basis: 200px;
  display: flex;
}
.media-id {
  text-overflow: ellipsis;
  overflow: hidden;
  flex-basis: 150px;
  flex-grow: 1;
}
.comments {
  text-overflow: ellipsis;
  overflow: hidden;
  flex-basis: 100px;
  flex-grow: 1;
  position: relative;
  display: flex;
  align-items: center;
}
.comments div[contenteditable=true] {
  outline: none;
  height: 18px;
  line-height: 14px;
  width: 80%;
  position: relative;
  z-index: 1;
  padding: 0;
  resize: none;
  overflow: hidden;
  background-color: transparent;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 4px;
  cursor: text;
  transition:
    height 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out,
    padding 0.2s ease-in-out,
    z-index 0.2s ease-in-out;
}
.comments div[contenteditable=true]:empty:before {
  content: attr(data-placeholder);
  pointer-events: none;
  display: block;
  height: 1em;
  color: rgb(114, 125, 139);
}
.comments div[contenteditable=true]:focus {
  position: fixed;
  padding: 5px;
  background-color: #ffffff;
  z-index: 1000;
  overflow-y: auto;
  border: 1px solid rgb(114, 125, 139);
  width: 150px;
  min-height: 40px;
  resize: both;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.32);
}
.audio {
  flex-basis: 62px;
  text-align: center;
}
.audio-subtitles-graphics-ads-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 10px;
  line-height: 0;
}
.audio-subtitles-graphics-ads-flex-svg {
  height: 11px;
}
.subtitles {
  flex-basis: 76px;
  text-align: center;
}
.graphics {
  flex-basis: 76px;
  text-align: center;
}
.ads {
  flex-basis: 56px;
  text-align: center;
}
.editable-time span {
  border: none;
  outline: none;
  border-radius: 3px;
  margin-left: -5px;
  padding: 2px 5px;
}
.editable-time span[contenteditable=false]:hover:focus,
.editable-time span[contenteditable=false]:hover:active,
.editable-time span[contenteditable=false]:hover:hover,
.editable-time span[contenteditable=true]:focus,
.editable-time span[contenteditable=true]:active,
.editable-time span[contenteditable=true]:hover {
  border: 1px solid black;
  margin-left: -6px;
  transition: 0.2s all;
  cursor: text;
}
.origin-time-start,
.time-start {
  font-size: 11px;
  flex-basis: 90px;
}
.time-end {
  font-size: 11px;
  flex-basis: 90px;
}
.duration {
  font-size: 11px;
  flex-basis: 90px;
}
.duration .current-remaining-duration {
  background-color: #ffffff;
  border-radius: 25px;
  padding: 5px 8px;
  margin-left: -6.5px;
  color: #40c4ff;
  font-size: 10.5px;
  font-weight: bold;
}
.before-time {
  background-color: #efefef;
  color: #ef5350;
}
.time-passed {
  background-color: #ffffff;
  opacity: 0.5;
}
.hover {
  border: 1px solid #ef5350;
}
.push-mark {
  border-top: 1px solid #ef5350;
}
.highlight {
  z-index: 2;
  -ms-transform: scale(1.01, 1.02);
  -webkit-transform: scale(1.01, 1.02);
  transform: scale(1.01, 1.02);
  -webkit-box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
}
.capsul div > label {
  border-style: hidden;
  border-radius: 10px;
  background-color: white;
  font-weight: bold;
  color: #ef5350;
  height: 20px;
  padding-right: 5px;
  padding-left: 5px;
}
.disable-pointer-events > * {
  pointer-events: none;
}
.audio-subtitles-graphics-ads-capsul {
  border-radius: 50%;
  padding-left: 7px;
  padding-right: 7px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.grey {
  background-color: #879baf;
  color: white;
  font-size: 9px;
  font-family: OpenSans;
}
.blue {
  background-color: #40c4ff;
  color: white;
  font-size: 9px;
  font-family: OpenSans;
}
.purple {
  background-color: #a65bfa;
  color: white;
  font-size: 9px;
  font-family: OpenSans;
}
.yellow {
  background-color: #ffe707;
  color: black;
  font-size: 9px;
  font-family: OpenSans;
}
.current-time-line {
  left: 0;
  width: 100%;
  position: absolute;
  z-index: 3;
  background-color: #ff0000;
  height: 1px;
}
context-menu ul[style] {
  position: absolute !important;
}
.loader-bg-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
.contract-show {
  background-color: #eef2f6 !important;
  border: solid 1px #bccad8 !important;
}
.minimize-icon {
  height: 15px;
  width: 15px;
  cursor: pointer;
  flex-basis: 20px;
  z-index: 10;
}
.minimize-icon svg path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  height: 15px;
  width: 15px;
}
.rotate-icon svg.anchor path {
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  transform-origin: 480px -480px;
}
.rotate-icon svg path {
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  height: 15px;
  width: 15px;
}
.minimized-show {
  display: none;
}
.expanded-background-color {
  background-color: #ebf0f4;
  opacity: 1;
  border-bottom: none;
}
virtual-scroller {
  flex: 1;
}
.minimize-all {
  flex-basis: 20px;
}
.sec-event-indicator-icons {
  display: flex;
  flex-direction: row;
}
.sec-event-icon {
  display: flex;
  align-items: center;
  margin-left: 11px;
}
.sec-event-inactive {
  opacity: 0.5;
}
.show-hover-border {
  border: 2px solid #2dbbfc;
  box-sizing: border-box;
  z-index: 1000;
}
.show-expanded-hover-border {
  border-top: 2px solid #2dbbfc;
  border-left: 2px solid #2dbbfc;
  border-right: 2px solid #2dbbfc;
  box-sizing: border-box;
  z-index: 1000;
}
.sec-events-hover-border {
  border-bottom: 2px solid #2dbbfc;
  border-left: 2px solid #2dbbfc;
  border-right: 2px solid #2dbbfc;
}
.add-sec-event-drag-area {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  margin-top: 7px;
  margin-left: 15px;
  border: dashed 1px rgba(125, 143, 161, 0.5);
}
.add-sec-event-drag-area-border-hidden {
  border: none;
}
.add-sec-event-drag-border {
  border: 2px solid #2dbbfc;
}
.add-sec-event-icon {
  display: flex;
  align-items: center;
  margin-left: 35px;
  margin-right: 35px;
}
.add-sec-event-icon ::ng-deep svg path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
.rotate-add-sec-event-icon ::ng-deep svg path {
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.show-selected {
  background-color: #2196f3 !important;
  border-color: #2185d6 !important;
  opacity: 1 !important;
}
/*# sourceMappingURL=calendar-list.component.css.map */
